import AccountTransfersTable from './AccountTransfersTable'

export default AccountTransfersTable
